import { render, staticRenderFns } from "./sidebarSubItem.vue?vue&type=template&id=745bc5ca&"
import script from "./sidebarSubItem.vue?vue&type=script&lang=js&"
export * from "./sidebarSubItem.vue?vue&type=script&lang=js&"
import style0 from "./sidebarSubItem.vue?vue&type=style&index=0&id=745bc5ca&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/sidebarSubItem.vue
// module id = 139
// module chunks = 30